import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 22a10 10 0 110-20 10 10 0 010 20zm0-2a8 8 0 100-16 8 8 0 000 16z"/>
    <path fill="#34CEFF" d="M15.5 11.67l-4.88-3.25a.4.4 0 00-.62.33v6.5a.4.4 0 00.62.34l4.88-3.26a.4.4 0 000-.66z"/>
  </SvgIcon>
);